/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Currency {
    EUR = 0,
    GBP = 1,
    USD = 2,
}
